import { Controller } from "@hotwired/stimulus";
import AOS from "aos";

export default class extends Controller {
  connect() {
    // Skip AOS initialization on Today page to prevent layout shifts
    if (
      window.location.pathname === "/" ||
      window.location.pathname === "/pages/home"
    ) {
      return;
    }
    AOS.init();
  }
}
